module.exports = __webpack_public_path__ + "static/media/GZ.78ea658d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/ministries/GZ.svg
// module id = 243
// module chunks = 0